module.exports = __webpack_public_path__ + "static/parade-2020-house02-6fe247a7c4a42b620d071cb5a878bc30.jpg";